import { render, staticRenderFns } from "./login.component.vue?vue&type=template&id=1d2e10e6&scoped=true&"
import script from "./login.component.vue?vue&type=script&lang=js&"
export * from "./login.component.vue?vue&type=script&lang=js&"
import style0 from "./login.component.vue?vue&type=style&index=0&id=1d2e10e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e10e6",
  null
  
)

export default component.exports